import { createContext } from 'react';

export const ElementsCoordsContext = createContext({
  elementsCoords: {},
  setElementsCoords: coords => {},
});
